module.exports = "/virtual-football-league/img/amblems/left/logos/Chelsea.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Chelsea.png
// module id = 2063
// module chunks = 4